import { useCompetencyDrawerState } from '../competencyDrawerSlice';
import { useGetLevelUpDetailsQuery } from '../dataHooks';

export const useHasDataChanged = () => {
  const { comment, progressScore, uploadedImage, uploadedGif } = useCompetencyDrawerState();
  const { data: levelUpCompetencyDetails } = useGetLevelUpDetailsQuery();

  return (
    comment.getCurrentContent().hasText() ||
    progressScore !== levelUpCompetencyDetails?.progressPercentage ||
    !!uploadedImage ||
    !!uploadedGif
  );
};
